<div class="row mt-1" style="min-height:30px;">
    <div class="col-1">
        <div style="margin-top:5px;margin-left:10px;">
            <input   style="margin-left:10px;margin-right:5px;" type="checkbox" id="parkerRowHeader" name="parkerRowHeader" [(ngModel)]="allUpdateFlag"
            (click)="onCheckOnOffAllParkersForUpdate()"/> Select All
          </div>

    </div>
    
    <div class="col-10">
        <div class="btn-group" role="group" aria-label="search by alphabet" style="margin-right:30px;">
            <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="isGridModeSelected ('allFilterItems') ? 'active' : ''"  (click)="onSelectGridMode('allFilterItems')" >All Results</button>
          <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="isGridModeSelected ('gridExpiredRates') ? 'active' : ''"  (click)="onSelectGridMode('gridExpiredRates')" >Expired/No Rates: {{this.parkerStateService.parkerExpiredRates.length}}</button>
          <button type="button" class="btn btn-outline-primary btn-sm" style="padding-left:5px;"  [ngClass]="isGridModeSelected ('gridDuplicateKeyCards') ? 'active' : ''"  (click)="onSelectGridMode('gridDuplicateKeyCards')" >Duplicate Key Cards:  {{parkerStateService.parkerDuplicateKeyCards.length}}</button>
        </div>

        <div class="btn-group" role="group" aria-label="search by alphabet" style="margin-right:40px;">
            <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="isFilterSelected ('allFilterItems') ? 'active' : ''"  (click)="onFilterParkerData('allFilterItems')" >Show All</button>
          <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="isFilterSelected ('0-9') ? 'active' : ''"  (click)="onFilterParkerData('0-9')" >0-9</button>
          <button type="button" class="btn btn-outline-primary btn-sm" style="padding-left:5px;"  [ngClass]="isFilterSelected ('A') ? 'active' : ''"  (click)="onFilterParkerData('A')" >A</button>
          <button type="button" class="btn btn-outline-primary btn-sm" [ngClass]="isFilterSelected ('B') ? 'active' : ''" (click)="onFilterParkerData('B')">B</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('C') ? 'active' : ''" (click)="onFilterParkerData('C')">C</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('D') ? 'active' : ''" (click)="onFilterParkerData('D')">D</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('E') ? 'active' : ''" (click)="onFilterParkerData('E')">E</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('F') ? 'active' : ''" (click)="onFilterParkerData('F')">F</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('G') ? 'active' : ''" (click)="onFilterParkerData('G')">G</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('H') ? 'active' : ''" (click)="onFilterParkerData('H')">H</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('I') ? 'active' : ''" (click)="onFilterParkerData('I')">I</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('J') ? 'active' : ''" (click)="onFilterParkerData('J')">J</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('K') ? 'active' : ''" (click)="onFilterParkerData('K')">K</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('L') ? 'active' : ''" (click)="onFilterParkerData('L')">L</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('M') ? 'active' : ''" (click)="onFilterParkerData('M')">M</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('N') ? 'active' : ''" (click)="onFilterParkerData('N')">N</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('O') ? 'active' : ''" (click)="onFilterParkerData('O')">O</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('P') ? 'active' : ''" (click)="onFilterParkerData('P')">P</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('Q') ? 'active' : ''" (click)="onFilterParkerData('Q')">Q</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('R') ? 'active' : ''" (click)="onFilterParkerData('R')">R</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('S') ? 'active' : ''" (click)="onFilterParkerData('S')">S</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('T') ? 'active' : ''" (click)="onFilterParkerData('T')">T</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('U') ? 'active' : ''" (click)="onFilterParkerData('U')">U</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('V') ? 'active' : ''" (click)="onFilterParkerData('V')">V</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('W') ? 'active' : ''" (click)="onFilterParkerData('W')">W</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('X') ? 'active' : ''" (click)="onFilterParkerData('X')">X</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('Y') ? 'active' : ''" (click)="onFilterParkerData('Y')">Y</button>
          <button type="button" class="btn btn-outline-primary btn-sm"  [ngClass]="isFilterSelected ('Z') ? 'active' : ''" (click)="onFilterParkerData('Z')">Z</button>
        </div>
    </div>
</div>

<igx-grid #gridParkersV2MainGrid id="gridParkersV2MainGrid" [data]="this.parkerStateService.filteredParkers" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'Parker Profile List Empty'"  [clipboardOptions]="options" paste-handler (rowToggle)="rowToggle($event)">

<igx-column field="view" header=" " width="50px" required></igx-column>

<igx-column field="active" header="_" [sortable]="true" width="60px" required style="font-size:10px;"  [resizable]="true"> [sortable]="true" 
    <ng-template igxCell let-cell="cell">
        <input type="checkbox" id="parkerRowDetail{{cell.row.data.parkerId}}" name="parkerRowDetail{{cell.row.data.parkerId}}" 
        value="parkerRowDetail{{cell.row.data.parkerId}}"   style="margin-left:10px;" 
        [(ngModel)]="cell.row.data.massUpdateTargetFlag" (click)="onSelectParker(cell.row.data.parkerId)">
    </ng-template>
</igx-column>

<igx-column field="active" header="Active*" [sortable]="true" width="90px" required [sortable]="true" ></igx-column>
<igx-column field="cardNumber" header="Card No." width="150px" required [sortable]="true" ></igx-column>
<igx-column field="stallType" header="Stall Type" width="125px" required [sortable]="true" ></igx-column>
<igx-column field="stallNumber" header="Stall #" width="90px" required [sortable]="true" ></igx-column>
<igx-column field="companyName" header="Company" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="lastName" header="Name" width="150px" required [sortable]="true" >
    <ng-template igxCell let-cell="cell">
        {{cell.row.data.lastName}}, {{cell.row.data.firstName}} 
    </ng-template>
</igx-column>
<igx-column field="startDate" header="Start Date" width="100px" required   [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(value !== '0001-01-01T00:00:00'){
                {{ value | date : 'shortDate'}}
            }
               
        </div>
    </ng-template>
</igx-column>
<igx-column field="endDate" header="End Date" width="100px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(value !== '0001-01-01T00:00:00' && (value | date : 'shortDate') !== '1/1/01' ){
                  {{ value | date : 'shortDate'}}
            }
               
        </div>
    </ng-template>
</igx-column>
<igx-column field="rate" header="Rate" width="100px" required   [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
                {{ value | currency}}
        </div>
    </ng-template>
</igx-column>

<igx-column field="taxExempt" header="Tax Exempt" width="100px" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(value == true){
                Yes
            }
            @else {
                No
            }
        </div>
    </ng-template>
</igx-column>


<igx-column field="parkerPayType" header="Payment" width="125px" required  [sortable]="true" ></igx-column>
<igx-column field="deliveryType" header="Delivery" width="100px" required  [sortable]="true" ></igx-column>
<igx-column field="active" header="spACE" width="125px" required >
    <ng-template  igxCell let-cell="cell">
        @if(cell.row.data.isAcePortal == true){
            Portal User: Y
        }
        @else{
            Portal User: N
        }
        <br />
        @if(cell.row.data.isPortalCreditCardOnFile == true){
            CC On File: Y
        }
        @else{
            CC On File: N
        }
        <br />
        @if(cell.row.data.isPortalAutoPay == true){
            Auto Pay: Y
        }
        @else{
            Auto Pay: N
        }

        
    </ng-template>
</igx-column>
<igx-column field="active" header="Address" width="125px" required >
    <ng-template igxCell let-cell="cell">
        {{cell.row.data.address}}
        @if(cell.row.data.addressLine != ''){
            <br />{{cell.row.data.addressLine}}
        }
        @if(cell.row.data.city != '' || cell.row.data.state != '' || cell.row.data.zipCode != ''){
            <br />{{cell.row.data.city}} {{cell.row.data.state}} {{cell.row.data.zipCode}}
        }

        @if(cell.row.data.phone != '' ){
            <br />{{cell.row.data.phone}} 
        }
        <br />
</ng-template>
</igx-column>

<igx-column field="additionalVehicles" header="No. Vehicles" width="125px" required  [sortable]="true" >
    <ng-template igxCell let-value>
        <div style="text-align:center;width:100%;">{{ value }}</div>
    </ng-template>
</igx-column>

<!-- <igx-column field="active" header="Vehicle" width="125px" required >
    <ng-template  igxCell let-cell="cell">
        {{cell.row.data.vehicleLicense}}
        @if(cell.row.data.vehicleState != ''){
            <br />{{cell.row.data.vehicleState}}
        }
        @if(cell.row.data.vehicleMake != ''){
            <br />{{cell.row.data.vehicleMake}}
        }
        @if(cell.row.data.vehicleModel != ''){
            <br />{{cell.row.data.vehicleModel}}
        }
        @if(cell.row.data.vehicleColor != ''){
            <br />{{cell.row.data.vehicleColor}}
        }
    </ng-template>
</igx-column> -->

<ng-template igxGridDetail let-dataItem style="margin-top:20px;height:500px;width:1000px;" >
    <igx-tabs  [selectedIndex]="0" style="width:100%;">
        <igx-tab-item>
            <igx-tab-header>
                <span  class="ace-heading-text-tabs-level-2">Parker Information</span>
            </igx-tab-header>
            <igx-tab-content style="height:700px;margin-bottom:10px;margin-top:10px;width:100%">
                <app-parkers-v2-detail [parkerDetailInput]="dataItem"></app-parkers-v2-detail>
            </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
            <igx-tab-header>
                <span   class="ace-heading-text-tabs-level-2">Vehicles ({{dataItem.additionalVehicles}})</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
                <app-parkers-v2-additional-vehicles [parkerDetail]="dataItem"></app-parkers-v2-additional-vehicles>
               
            </igx-tab-content>
        </igx-tab-item>

        <igx-tab-item>
            <igx-tab-header>
                <span   class="ace-heading-text-tabs-level-2">Additional Emails ({{dataItem.additionalEmails}})</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
                 <app-parkers-v2-additional-emails [parkerDetail]="dataItem"></app-parkers-v2-additional-emails>
            </igx-tab-content>
        </igx-tab-item>

        <igx-tab-item *ngIf="showSpaceGridDisplayTab(dataItem.companyName)">
            <igx-tab-header>
                <span   class="ace-heading-text-tabs-level-2">spACE Email(s)</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
               <app-parkers-v2-space-email [parkerDetail]="dataItem"></app-parkers-v2-space-email>
            </igx-tab-content>
        </igx-tab-item>

        <igx-tab-item>
            <igx-tab-header>
                <span   class="ace-heading-text-tabs-level-2">Monthly Parking Agreement</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
               <app-parkers-v2-agreement [parkerDetail]="dataItem"></app-parkers-v2-agreement>
            </igx-tab-content>
        </igx-tab-item>

        
            <!-- <igx-tab-item>
                <igx-tab-header>
                    <span   class="ace-heading-text-tabs-level-2">PARCS</span>
                </igx-tab-header>
                <igx-tab-content  style="height:600px;">
                   <app-parcs-management-home [parkerDetail]="dataItem"></app-parcs-management-home>
                </igx-tab-content>
            </igx-tab-item> -->
        
        
        <!-- @if(this._appGeneralState.currentLotNumber == '1004' || this._appGeneralState.currentLotNumber == '4258'){     -->
        <igx-tab-item>
            <igx-tab-header>
                <span   class="ace-heading-text-tabs-level-2">Additional Credentials</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
               <app-parkers-v2-additional-credentials [parkerDetail]="dataItem"></app-parkers-v2-additional-credentials>
            </igx-tab-content>
        </igx-tab-item>
        <!-- } -->

        @if(hasParc){
           
             <igx-tab-item>
            <igx-tab-header>
                 @if(this._appGeneralState.hasLinkedParcsAccount){
                <span   class="ace-heading-text-tabs-level-2">PARCS</span>
                 }
                 @else if(this._appGeneralState.hasLinkedParcsAccount == false){
                    <span   class="ace-heading-text-tabs-level-2">PARCS/Not Linked</span>
                 }
                 @else if(this._appGeneralState.hasLinkedParcsAccount === undefined){
                    <span   class="ace-heading-text-tabs-level-2">Getting PARCS Status...</span>
                 }

            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
                @if(this._appGeneralState.parcsDisplayName.toUpperCase() == 'AMANO ONE'){
                    <app-parcs-management-home [parkerDetail]="dataItem"></app-parcs-management-home>
                }
                @else if(this._appGeneralState.parcsDisplayName.toUpperCase() == 'FLASH'){
                    <app-flash-parker-settings [parkerDetail]="dataItem"></app-flash-parker-settings>
                }
               
            </igx-tab-content>
        </igx-tab-item>
        }
    </igx-tabs>
</ng-template>

<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>





